"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var core_1 = require("@material-ui/core");
var react_intl_1 = require("react-intl");
var LocationIcon_1 = __importDefault(require("../assets/icon/LocationIcon"));
var PhoneIcon_1 = __importDefault(require("../assets/icon/PhoneIcon"));
var MailIcon_1 = __importDefault(require("../assets/icon/MailIcon"));
var useStyles = core_1.makeStyles(function (theme) { return core_1.createStyles({
    root: {
        position: 'relative',
        backgroundColor: '#202E25',
        overflow: 'hidden',
        width: '100%',
        color: '#ffffff'
    },
    container: {
        marginBottom: '0px',
        position: 'relative',
        backgroundColor: '#202E25',
        overflow: 'hidden',
        width: '100%',
        color: '#ffffff'
    },
    card: {
        backgroundColor: 'transparent',
        boxShadow: 'none',
    },
    dir: {
        height: '1px',
        backgroundColor: "#FFF"
    },
    title: {
        display: 'flex',
        color: "#FFF",
        fontSize: 14,
    },
    ipr: {
        borderRadius: '0px',
        backgroundColor: '#33473A',
        textAlign: "center",
        color: "#A0A0A0",
        fontSize: 14,
    },
    icon: {
        htmlColor: "#fff",
        marginRight: theme.spacing(0.5),
        width: 20,
        height: 20,
    }
}); });
var FooterLayout = function () {
    var classes = useStyles();
    return (
    // <div className = {classes.root}>
    react_1.default.createElement(core_1.Container, { maxWidth: "xl", className: classes.container },
        react_1.default.createElement(core_1.Grid, { className: classes.root, container: true, spacing: 1 },
            react_1.default.createElement(core_1.Grid, { item: true, xs: 12, sm: 8 },
                react_1.default.createElement(core_1.Card, { className: classes.card },
                    react_1.default.createElement(core_1.CardHeader, { className: classes.title, title: react_1.default.createElement(react_intl_1.FormattedMessage, { id: "about" }) }),
                    react_1.default.createElement(core_1.Divider, { className: classes.dir, variant: "middle" }),
                    react_1.default.createElement(core_1.CardContent, null,
                        react_1.default.createElement(core_1.Typography, { className: classes.title, color: "textSecondary", gutterBottom: true },
                            react_1.default.createElement(react_intl_1.FormattedMessage, { id: "aboutContent" }))))),
            react_1.default.createElement(core_1.Grid, { item: true, xs: 12, sm: 4 },
                react_1.default.createElement(core_1.Card, { className: classes.card },
                    react_1.default.createElement(core_1.CardHeader, { className: classes.title, title: react_1.default.createElement(react_intl_1.FormattedMessage, { id: "contact" }) }),
                    react_1.default.createElement(core_1.Divider, { className: classes.dir, variant: "middle" }),
                    react_1.default.createElement(core_1.CardContent, null,
                        react_1.default.createElement(core_1.Typography, { className: classes.title, color: "textSecondary", gutterBottom: true },
                            react_1.default.createElement(PhoneIcon_1.default, { className: classes.icon }),
                            " : +886-2-8228-2578"),
                        react_1.default.createElement(core_1.Typography, { className: classes.title, color: "textSecondary", gutterBottom: true },
                            react_1.default.createElement(LocationIcon_1.default, { className: classes.icon }),
                            " : ",
                            react_1.default.createElement(react_intl_1.FormattedMessage, { id: "address" })),
                        react_1.default.createElement(core_1.Typography, { className: classes.title, color: "textSecondary", gutterBottom: true },
                            react_1.default.createElement(MailIcon_1.default, { className: classes.icon }),
                            " : service@ioshop.com.tw")))),
            react_1.default.createElement(core_1.Grid, { item: true, xs: 12 },
                react_1.default.createElement(core_1.Paper, { className: classes.ipr },
                    react_1.default.createElement(core_1.Typography, null, "Copyright \u24D2 2020 \u91D1\u5BEC\u6709\u9650\u516C\u53F8")))))
    // </div>
    );
};
exports.default = FooterLayout;
